/* ================================================== */
/* STICKYFILL
/* ================================================== */

$(document).ready(function() {
	var elements = $('.position-sticky');
	Stickyfill.add(elements);
});